import React, { useEffect } from "react";
import { trackEvent, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";

function AutoLoans() {
  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Auto Loans</h1>
        <p className="text-lg text-gray-600">Coming soon...</p>
      </div>
    </div>
  );
}

export default AutoLoans;
